'use client'

import { API_AUTH_REGISTER_EVENT_INSTANT_URL } from '@/consts/baseUrls'
import { clearUtmFromStorage, getUtmFromStorage } from '@/hooks/useUrlParams'
import axios, { axiosPkg } from '@/utils/axios'
import { useParams, useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'

export default function EventInstantPage() {
    const router = useRouter()
    const params = useParams<{ eventId: string }>()
    const eventId = params?.eventId
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        let isMounted = true

        const run = async () => {
            if (!eventId) {
                if (isMounted) setError('Event ID missing.')
                return
            }

            try {
                const utm = getUtmFromStorage()

                // Route hit should directly provision a fresh event-instant user.
                const result = await axios.post(
                    API_AUTH_REGISTER_EVENT_INSTANT_URL,
                    { eventId, ...(utm ? { utm } : {}) },
                    { withCredentials: true },
                )

                if (result.status < 200 || result.status >= 300) {
                    if (isMounted) setError(result.data?.error ?? 'Event login failed.')
                    return
                }

                clearUtmFromStorage()
                router.replace('/chat')
            } catch (error) {
                if (!isMounted) return

                if (axiosPkg.isAxiosError(error)) {
                    if (error.response?.status === 404) {
                        router.replace('/auth')
                        return
                    }
                    setError(error.response?.data?.error ?? 'Event login failed.')
                    return
                }
                setError('Event login failed.')
            }
        }

        run()

        return () => {
            isMounted = false
        }
    }, [eventId, router])

    return (
        <div>
            <h1>Event Login</h1>
            {error ? <p>{error}</p> : <p>Please wait...</p>}
        </div>
    )
}
